<template>
    <div class="flex flex-col z-[99] relative" tabindex="0" @blur="close">
        <div class="flex flex-row items-center h-10 p-2 bg-gray-black rounded" :class="disabled?'cursor-not-allowed':'cursor-pointer'">
            <div class="flex flex-row w-full" @click="toggleOpen">
                <div class="mt-1 mr-1">
                    <svg class="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none" stroke="#ffffff"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <path d="M12 7V12L14.5 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                </div>
                <div class="flex w-full" :class="modelValue?'text-white':'text-grey'">
                    <div class="inline-block truncate">{{modelValue?formatTime():placeholder}}</div>
                </div>
            </div>
            <div v-if="modelValue" @click="clearAll()" class="mr-1"><svg class="w-[12px] h-[12px]" viewBox="0 -0.5 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>close [#ffffff]</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-419.000000, -240.000000)" fill="#ffffff"> <g id="icons" transform="translate(56.000000, 160.000000)"> <polygon id="close-[#ffffff]" points="375.0183 90 384 98.554 382.48065 100 373.5 91.446 364.5183 100 363 98.554 371.98065 90 363 81.446 364.5183 80 373.5 88.554 382.48065 80 384 81.446"> </polygon> </g> </g> </g> </g></svg></div>
        </div>
        <div v-if="open" class="flex flex-col z-[999] absolute top-[41px] w-full max-h-96 overflow-auto">
            <div class="relative grid grid-cols-3 p-2 border-t border-light-black bg-theme-modalbg h-[180px] overflow-hidden">
                <div class="flex flex-col overflow-auto" style="-ms-overflow-style: none;scrollbar-width: none;">
                    <div v-for="each in 12" :key="each" @click="selectHH(each)" class="p-[15px] hover:bg-theme-grey cursor-pointer text-center" :class="selectedHH==each?'bg-theme-grey':''">{{ each }}</div>
                </div>
                <div class="flex flex-col overflow-auto" style="-ms-overflow-style: none;scrollbar-width: none;">
                    <div v-for="(val, each) in 60" :key="each" @click="selectMM(each)" class="p-[15px] hover:bg-theme-grey cursor-pointer text-center" :class="selectedMM==each?'bg-theme-grey':''">
                        {{ each }}
                    </div>
                </div>
                <div class="flex flex-col">
                    <div @click="selectMid('AM')" class="p-[15px] hover:bg-theme-grey cursor-pointer text-center" :class="selectedMid=='AM'?'bg-theme-grey':''">AM</div>
                    <div @click="selectMid('PM')" class="p-[15px] hover:bg-theme-grey cursor-pointer text-center" :class="selectedMid=='PM'?'bg-theme-grey':''">PM</div>
                </div>
            </div>
        </div>
    </div>
    </template>
    <script>
    import {defineComponent} from 'vue'
    export default defineComponent({
        props: {
            modelValue: String,
            placeholder:String,
            options: Array,
            disabled: Boolean
        },
        data(){
            return {
                open: false,
                selectedHH: '1',
                selectedMM: '00',
                selectedMid: 'AM',
            }
        },
        mounted(){
            let time = this.modelValue
            this.getInitialTime(time)

        },
        watch: {
            modelValue(){
                let time = this.modelValue
                this.getInitialTime(time)
            },
            search(){
                this.filteredOptions = this.options.filter(each => each.name.toLowerCase().includes(this.search.toLowerCase()))?.sort((a, b) => a.name.localeCompare(b.name))
            }
        },
        methods: {
            getInitialTime(time){
                if(time){
                    this.selectedHH = (parseInt(time.split(':')[0])>12)?(parseInt(time.split(':')[0])-12):((parseInt(time.split(':')[0])==0)?'12':time.split(':')[0])
                    this.selectedMM = time.split(':')[1]
                    this.selectedMid = (parseInt(time.split(':')[0])>11)?'PM':'AM'
                }
            },
            toggleOpen(){
                if(!this.disabled){
                    this.open = !this.open
                }
            },
            close(e){
                if(e && !e.relatedTarget){
                    this.open = false
                }
            },
            formatTime(){
                let hh = this.selectedHH?parseInt(this.selectedHH):'1'
                let mm = this.selectedMM?this.selectedMM:'00'
                let mid = this.selectedMid?this.selectedMid:'AM'
                return hh + ':' + mm + ' ' + mid
            },
            getDefault(hh, mm, mid){
                let hhTime = ''
                let mmTime = ''
                let midTime = ''
                hhTime = hh ? hh : (this.selectedHH?this.selectedHH:'01')
                midTime = mid ? mid : (this.selectedMid?this.selectedMid:'AM')
                if(midTime=='PM' || mid=='PM') {
                    if(hhTime==12){
                        hhTime = (parseInt(hhTime)).toString()
                    }else{
                        hhTime = (parseInt(hhTime) + 12).toString()
                    }
                }else if(midTime=='AM' || mid=='AM'){
                    if(hhTime==12){
                        hhTime = '00'
                    }else{
                        hhTime = ('0'+hhTime).slice(-2)
                    }
                }else{
                    if(hhTime<10){
                        hhTime = ('0'+hhTime).slice(-2)
                    }
                }
                mmTime = mm ? mm : (this.selectedMM?this.selectedMM:'00')
                return hhTime + ':' + mmTime + ':00'
            },
            getTime(){
                return this.selectedHH + ':' + this.selectedMM + ' ' + this.selectedMid
            },
            selectHH(hh){
                this.selectedHH = ('0'+hh).slice(-2)
                this.$emit('update:modelValue', this.getDefault(this.selectedHH, null, null))
            },
            selectMM(mm){
                this.selectedMM = ('0'+mm).slice(-2)
                this.$emit('update:modelValue', this.getDefault(null, this.selectedMM, null))
            },
            selectMid(mid){
                this.selectedMid = mid
                this.$emit('update:modelValue', this.getDefault(null, null, this.selectedMid))
            },
            clearAll(){
                this.selectedHH = ''
                this.selectedMM = ''
                this.selectedMid = ''
                this.$emit('update:modelValue', '')
            }

        }
    })
    </script>